/**
 * Catalogo delle **Mosse Comuni** DWR (manuale V1 rr. 1781-1822).
 *
 * Le mosse comuni sono disponibili in modo trasversale (cross-class) sotto
 * condizioni precise di livello / prerequisiti. Sono distinte dalle:
 *  - mosse di **classe** (`starting` + `advanced_2_5` + `advanced_6_10`) →
 *    `src/data/moves/<classe>/`
 *  - mosse **base** (universali, tutti i PG le hanno) → `src/data/moves/base/`
 *    (categoria non ancora trascritta nel progetto)
 *  - mosse **system** (cornice del sistema) → idem
 *
 * **Disponibilità delle 6 mosse comuni**:
 *  - *Infanzia Complessa*: esattamente al 2° livello (logica in
 *    `services/commonMovesAvailability.ts::isCommonMoveAvailable`)
 *  - 5 mosse multiclasse a catena (*Apprendista → Adepto → Esperto →
 *    Maestro → Gran Maestro Multiclasse*): post-10° livello per PG
 *    Apprendista/Instancabile (D10 / FI-11). Pool aperto `any-other-class`
 *    + `levelAdjustment` per restringere il tipo di mossa-target.
 *
 * **Type**: tutte hanno `MoveType: 'common'` (FI-10 chiuso).
 */

import type { Move } from '../../../schemas/move';
import { adeptoMulticlasse } from './adepto-multiclasse';
import { apprendistaMulticlasse } from './apprendista-multiclasse';
import { espertoMulticlasse } from './esperto-multiclasse';
import { granMaestroMulticlasse } from './gran-maestro-multiclasse';
import { infanziaComplessa } from './infanzia-complessa';
import { maestroMulticlasse } from './maestro-multiclasse';

export const commonMoves: readonly Move[] = [
  infanziaComplessa,
  // D10 / FI-11: 5 mosse multiclasse post-10° a catena
  apprendistaMulticlasse,
  adeptoMulticlasse,
  espertoMulticlasse,
  maestroMulticlasse,
  granMaestroMulticlasse,
];

/**
 * Lookup di una mossa comune per ID.
 * Restituisce `undefined` se l'ID non corrisponde a nessuna mossa comune.
 */
export function findCommonMoveById(moveId: string): Move | undefined {
  return commonMoves.find((m) => m.id === moveId);
}
